import * as ApiManager from './_manager';
import store from '@/store';

export const program = {
  get: (payload = null) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/program/get`,
      payload
    );
  },
};
